import { CommonRequestOptions, makeRequest } from '../makeRequest';
import { SkillRatingId } from './skill-rating-id';
import { SkillRatingConstituentType } from './skill-rating-constituents';

export type SkillRatingConstituent = {
   isEditableByCurrentUser: boolean;
   weight: number;
   value: number;
   weighted_value: number;
};

export type SkillRating = {
   total: number;
   constituents: Record<SkillRatingConstituentType, SkillRatingConstituent>;
};

export async function getSkillRating(
   { doctype, docid, userid }: Partial<SkillRatingId>,
   teamid?: number,
   common: CommonRequestOptions = {}
): Promise<SkillRating | null> {
   if (!doctype || !docid || !userid) return null;
   let endpoint = `skills/ratings/${doctype}/${docid}/${userid}`;
   if (teamid) {
      endpoint += `?teamid=${teamid}`;
   }
   return makeRequest('get', endpoint, common);
}
